// Inline picker for tying an e-Transfer to a customer (and optionally a
// site). "Always match this sender" teaches Command the sender name so
// the next e-Transfer from them is matched automatically.

import { useEffect, useState } from 'react';
import axios from 'axios';

export default function EtransferAssign({ row, onDone, onCancel }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [pick, setPick] = useState(row.contact_id ? { contact_id: row.contact_id, company: row.company } : null);
  const [sites, setSites] = useState([]);
  const [siteId, setSiteId] = useState(row.site_id || '');
  const [remember, setRemember] = useState(true);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return undefined; }
    const t = setTimeout(() => {
      axios.get('/api/etransfers/lookup', { params: { q } })
        .then((r) => setResults(r.data.results || [])).catch(() => {});
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  useEffect(() => {
    if (!pick) { setSites([]); return; }
    axios.get(`/api/etransfers/sites/${pick.contact_id}`).then((r) => setSites(r.data.sites || [])).catch(() => {});
  }, [pick?.contact_id]);

  function choose(r) {
    setPick({ contact_id: r.contact_id, company: r.company });
    setSiteId(r.site_id || '');
    setQ('');
    setResults([]);
  }

  async function save() {
    if (!pick) return;
    setSaving(true);
    setErr(null);
    try {
      const r = await axios.patch(`/api/etransfers/${row.id}`, { contact_id: pick.contact_id, site_id: siteId || null, remember });
      onDone(r.data);
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
      setSaving(false);
    }
  }

  return (
    <div className="et-assign">
      {!pick && (
        <div className="et-assign-search">
          <input autoFocus placeholder="Search customer, site name, site # or city…" value={q} onChange={(e) => setQ(e.target.value)} />
          {results.length > 0 && (
            <div className="et-assign-results">
              {results.map((r) => (
                <button type="button" key={`${r.contact_id}-${r.site_id || 0}`} onClick={() => choose(r)}>
                  <strong>{r.company || '(no company)'}</strong>
                  {r.site_id
                    ? <span> · {r.site_name || r.site_number}{r.site_number && r.site_name ? ` (${r.site_number})` : ''}</span>
                    : <span className="calls-dim"> · customer</span>}
                  {r.city && <span className="calls-dim"> · {r.city}</span>}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
      {pick && (
        <div className="et-assign-picked">
          <span><strong>{pick.company}</strong> <button type="button" className="em-clear" onClick={() => { setPick(null); setSiteId(''); }}>change</button></span>
          {sites.length > 0 && (
            <select value={siteId} onChange={(e) => setSiteId(e.target.value)}>
              <option value="">No specific site</option>
              {sites.map((s) => (
                <option key={s.id} value={s.id}>{s.site_name || s.site_number}{s.site_number && s.site_name ? ` (${s.site_number})` : ''}{s.city ? ` · ${s.city}` : ''}</option>
              ))}
            </select>
          )}
          <label className="et-remember">
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            Always match “{row.sender_name}” to this customer
          </label>
        </div>
      )}
      {err && <p className="calls-error">{err}</p>}
      <div className="et-assign-actions">
        <button type="button" className="btn btn-primary btn-sm" disabled={!pick || saving} onClick={save}>{saving ? 'Saving…' : 'Save'}</button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
